import React from 'react'

export default function StatusChangeIcon() {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="7.99957" cy="7.97222" r="5.64444" stroke="#64617E" strokeWidth="1.15556" />
            <circle cx="8.00087" cy="7.97157" r="2.97778" stroke="#64617E" strokeWidth="1.15556" />
        </svg>
    )
}
